"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./lib/index"));

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/angular2-color-picker/index.js
// module id = 162
// module chunks = 1